import { useState, useEffect, useMemo, useCallback } from 'react';
import data from '../data.json';

export const translations = {
  kannada: {
    villageSelectionTitle: 'ಪರಿಹಾರದ ವಿವರ ತಿಳಿಯಲು ಗ್ರಾಮವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ',
    taluk: 'ತಾಲ್ಲೂಕು',
    hobli: 'ಹೋಬಳಿ',
    grama: 'ಗ್ರಾಮ',
    mainTitle: 'ಗ್ರಾಮವಾರು ಭೂ ಪರಿಹಾರದ ವಿವರ',
    oldCompensationTitle: 'ಹಳೆಯ ಕಾಯ್ದೆಯ ಪ್ರಕಾರ (ಪ್ರತಿ ಎಕರೆಗೆ)',
    oldCompensationText: 'ಸಾಮಾನ್ಯ ಐತೀರ್ಪು ಪರಿಹಾರದ ಮೊತ್ತ:',
    newCompensationTitle: 'ಹೊಸ ಪರಿಹಾರದ ಆಯ್ಕೆಗಳು (ಪ್ರತಿ ಎಕರೆಗೆ)',
    newCompensationOptions: [
      'ಸಂಧಾನಿತ ಮೊತ್ತ:',
      '65:35 ಅನುಪಾತದಲ್ಲಿ ಅಭಿವೃದ್ಧಿಪಡಿಸಿದ ವಾಣಿಜ್ಯ ನಿವೇಶನಗಳು:',
      'ಅಭಿವೃದ್ಧಿಪಡಿಸಿದ ವಸತಿ ನಿವೇಶನಗಳನ್ನು ಪರಿಹಾರ ರೂಪದಲ್ಲಿ ನೀಡುವ ಬಗ್ಗೆ: ಸಂಧಾನಿತ ಮೊತ್ತದ ಮೌಲ್ಯವನ್ನು ಮೀರದಂತೆ',
      'ವರ್ಗಾವಣೆ ಮಾಡಬಹುದಾದ ಅಭಿವೃದ್ಧಿ ಹಕ್ಕುಗಳು (Transferable Development Rights - TDR):',
      'ಮಹಡಿ ಪ್ರದೇಶದ ಅನುಪಾತ (Floor Area Ratio - FAR): ಬೆಂಗಳೂರು ಸ್ಥಳೀಯ ಯೋಜನಾ ಪ್ರದೇಶದ ಆರ್.ಎಂ.ಪಿ- 2015 ರ ವಲಯ ನಿಯಮಾವಳಿಗಳಿಗೆ ಅನುಗುಣವಾಗಿ'
    ],
    footerPolicies: 'ನೀತಿಗಳು ಮತ್ತು ಮಾರ್ಗಸೂಚಿಗಳು',
    footerAdditional: 'ಹೆಚ್ಚುವರಿ ಮಾಹಿತಿ',
    followUs: 'ನಮ್ಮನ್ನು ಅನುಸರಿಸಿ:',
    copyright: '© 2025 - ಬೆಂಗಳೂರು ಬ್ಯುಸಿನೆಸ್ ಕಾರಿಡಾರ್ - ಎಲ್ಲ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.',
    disclaimer: 'ಈ ಪುಟವು ಸರ್ಕಾರಿ ವೆಬ್‌ಸೈಟ್/ಪುಟಗಳಿಗೆ ಲಿಂಕ್ ಮಾಡುತ್ತದೆ ಮತ್ತು ಆ ವೆಬ್‌ಸೈಟ್‌ಗಳ ವಿಷಯವು ಸಂಬಂಧಿತ ಸಂಸ್ಥೆಗಳಿಗೆ ಸೇರಿದೆ. ಹೆಚ್ಚಿನ ಮಾಹಿತಿಗಾಗಿ ಅವರನ್ನು ಸಂಪರ್ಕಿಸಿ.',
    helpline: '24×7 ಹೆಲ್ಪ್‌ಲೈನ್',
    grievanceText: 'ನಿಮ್ಮ ದೂರನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ',
    grievanceLink: 'https://bda.karnataka.gov.in/grievance/public/',
    footerLinks: {
      copyright: 'ಕೃತಿಸ್ವಾಮ್ಯ ನೀತಿ',
      privacy: 'ಗೌಪ್ಯತಾ ನೀತಿ',
      hyperlinking: 'ಹೈಪರ್‌ಲಿಂಕಿಂಗ್ ನೀತಿ',
      security: 'ಭದ್ರತಾ ನೀತಿ',
      screenReader: 'ಸ್ಕ್ರೀನ್ ರೀಡರ್ ಪ್ರವೇಶ',
      help: 'ಸಹಾಯ',
      terms: 'ನಿಯಮ ಮತ್ತು ಶರತ್ತುಗಳು',
      guidelines: 'ಮಾರ್ಗಸೂಚಿಗಳು',
      disclaimer: 'ಹಕ್ಕುತ್ಯಾಗ'
    }
  },
  english: {
    villageSelectionTitle: 'Select the village to know the compensation details',
    taluk: 'Taluk',
    hobli: 'Hobli',
    grama: 'Village',
    mainTitle: 'Village-wise Land Compensation Details',
    oldCompensationTitle: 'As per Old Act (per acre)',
    oldCompensationText: 'General Award Compensation Amount:',
    newCompensationTitle: 'New Compensation Options (per acre)',
    newCompensationOptions: [
      'Negotiated Amount:',
      'Commercial plots developed in 65:35 ratio:',
      'Regarding giving developed residential plots as compensation: Not exceeding the negotiated amount value',
      'Transferable Development Rights (TDR):',
      'Floor Area Ratio (FAR): As per RMP-2015 zonal regulations of Bengaluru local planning area'
    ],
    footerPolicies: 'Policies and Guidelines',
    footerAdditional: 'Additional Information',
    followUs: 'Follow Us on:',
    copyright: '© 2025 - Bengaluru Business Corridor - All rights reserved.',
    disclaimer: 'This page links to government websites/pages and the content of those websites belongs to respective organizations. Contact them for more information.',
    helpline: '24×7 Helpline',
    grievanceText: 'Raise Your Grievance Here',
    grievanceLink: 'https://bda.karnataka.gov.in/grievance/public/',
    footerLinks: {
      copyright: 'Copyright Policy',
      privacy: 'Privacy Policy',
      hyperlinking: 'Hyperlinking Policy',
      security: 'Security Policy',
      screenReader: 'Screen Reader Access',
      help: 'Help',
      terms: 'Terms and Conditions',
      guidelines: 'Guidelines',
      disclaimer: 'Disclaimer'
    }
  }
};

export const useCompensation = (externalLanguage = null, externalSetLanguage = null) => {
  const [internalLanguage, setInternalLanguage] = useState('kannada');
  const [selectedTalukId, setSelectedTalukId] = useState(null);
  const [selectedHobliId, setSelectedHobliId] = useState(null);
  const [selectedVillageId, setSelectedVillageId] = useState(null);
  const [villageData, setVillageData] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const language = externalLanguage !== null ? externalLanguage : internalLanguage;
  const setLanguage = externalSetLanguage !== null ? externalSetLanguage : setInternalLanguage;
  const t = translations[language];

  const getTaluks = useCallback(() => {
    return data.taluks.map(taluk => ({
      id: taluk.id,
      displayName: language === 'kannada' ? taluk.name_kn : taluk.name_en,
      name_en: taluk.name_en,
      name_kn: taluk.name_kn
    }));
  }, [language]);

  const getHoblis = useCallback(() => {
    if (!selectedTalukId) return [];
    const taluk = data.taluks.find(t => t.id === selectedTalukId);
    if (!taluk) return [];
    return taluk.hoblis.map(hobli => ({
      id: hobli.id,
      displayName: language === 'kannada' ? hobli.name_kn : hobli.name_en,
      name_en: hobli.name_en,
      name_kn: hobli.name_kn
    }));
  }, [selectedTalukId, language]);

  const getVillages = useCallback(() => {
    if (!selectedTalukId || !selectedHobliId) return [];
    const taluk = data.taluks.find(t => t.id === selectedTalukId);
    if (!taluk) return [];
    const hobli = taluk.hoblis.find(h => h.id === selectedHobliId);
    if (!hobli) return [];
    return hobli.villages.map(village => ({
      id: village.id,
      displayName: language === 'kannada' ? village.name_kn : village.name_en,
      name_en: village.name_en,
      name_kn: village.name_kn
    }));
  }, [selectedTalukId, selectedHobliId, language]);

  const getSelectedTaluk = useCallback(() => {
    if (!selectedTalukId) return null;
    return getTaluks().find(t => t.id === selectedTalukId);
  }, [selectedTalukId, getTaluks]);

  const getSelectedHobli = useCallback(() => {
    if (!selectedHobliId) return null;
    return getHoblis().find(h => h.id === selectedHobliId);
  }, [selectedHobliId, getHoblis]);

  const getSelectedVillage = useCallback(() => {
    if (!selectedVillageId) return null;
    return getVillages().find(v => v.id === selectedVillageId);
  }, [selectedVillageId, getVillages]);

  const handleTalukChange = useCallback((taluk) => {
    setSelectedTalukId(taluk.id);
    setSelectedHobliId(null);
    setSelectedVillageId(null);
    setVillageData(null);
    setIsSubmitted(false);
  }, []);

  const handleHobliChange = useCallback((hobli) => {
    setSelectedHobliId(hobli.id);
    setSelectedVillageId(null);
    setVillageData(null);
    setIsSubmitted(false);
  }, []);

  const handleVillageChange = useCallback((village) => {
    setSelectedVillageId(village.id);
    setVillageData(null);
    setIsSubmitted(false);
  }, []);

  const handleSubmit = useCallback(() => {
    if (selectedTalukId && selectedHobliId && selectedVillageId) {
      const taluk = data.taluks.find(t => t.id === selectedTalukId);
      if (taluk) {
        const hobli = taluk.hoblis.find(h => h.id === selectedHobliId);
        if (hobli) {
          const village = hobli.villages.find(v => v.id === selectedVillageId);
          if (village) {
            setVillageData({
              taluk: {
                id: taluk.id,
                name_en: taluk.name_en,
                name_kn: taluk.name_kn
              },
              hobli: {
                id: hobli.id,
                name_en: hobli.name_en,
                name_kn: hobli.name_kn
              },
              village: village
            });
            setIsSubmitted(true);
            setTimeout(() => {
              const resultsSection = document.querySelector('.main-content');
              if (resultsSection) {
                resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }, 100);
          }
        }
      }
    }
  }, [selectedTalukId, selectedHobliId, selectedVillageId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formatCurrency = useCallback((amount) => {
    return new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 0
    }).format(amount);
  }, []);

  const canSubmit = useMemo(() => 
    selectedTalukId && selectedHobliId && selectedVillageId,
    [selectedTalukId, selectedHobliId, selectedVillageId]
  );

  return {
    language,
    setLanguage,
    selectedTalukId,
    selectedHobliId,
    selectedVillageId,
    villageData,
    isSubmitted,
    t,
    translations,
    getTaluks,
    getHoblis,
    getVillages,
    getSelectedTaluk,
    getSelectedHobli,
    getSelectedVillage,
    handleTalukChange,
    handleHobliChange,
    handleVillageChange,
    handleSubmit,
    formatCurrency,
    canSubmit
  };
};
